import {ReactNode} from 'react';
import {Navigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {useIVOnProperty} from 'hooks/useIVOnProperty';
import {useIVStore} from '@chekin/shared';

type IVQRGuardProps = {
  children: ReactNode;
};

function IVQRGuard({children}: IVQRGuardProps) {
  const {getFullPath} = usePath();
  const {isIVOnPropertyAvailable} = useIVOnProperty();
  const isPropertyQRScanned = useIVStore(state => state.isPropertyQRScanned);

  if (isIVOnPropertyAvailable && !isPropertyQRScanned) {
    return (
      <Navigate
        to={getFullPath(`${PATHS.verification.main}/${PATHS.verification.qrScan}`)}
        replace
      />
    );
  }

  return <>{children}</>;
}

export {IVQRGuard};
